import React from "react";
import styled from "styled-components";
import { theme } from "../theme/config";
import logo from "../assets/images/logo.svg";
import betterworkplace from "../assets/images/betterworkplace-logo.svg";
import { useScrollSection } from "react-scroll-section";
import { Container } from "../theme/shared";
import { Link } from "react-router-dom";

const Section = styled.div`
  background: ${theme.colors.green.default};
`;

const MenuContainer = styled(Container)`
  display: flex;
  padding: 0 2.5rem 50px;
  box-sizing: border-box;
  @media (max-width: ${theme.breakpoints.desktop.max}) {
    padding: 0 2.5rem 40px;
  }
`;

const Logo = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 60px;
`;

const ImgMobile = styled.img`
  display: none;
  width: 142px;
  height: 142px;
  @media (max-width: ${theme.breakpoints.desktop.max}) {
    display: block;
  }
`;

const ImgDesktop = styled.img`
  display: block;
  @media (max-width: ${theme.breakpoints.desktop.max}) {
    display: none;
  }
`;

const ImgBetterWorkplace = styled.div`
  background: #fff;
  border-radius: 50%;
  width: 202px;
  height: 202px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  @media (max-width: ${theme.breakpoints.desktop.max}) {
    width: 142px;
    height: 142px;
  }

  img {
    max-width: 80%;
    vertical-align: middle;
    margin: 0 !important;
  }
`;

function Top() {
  const homeSection = useScrollSection("home");
  return (
    <Section>
      <MenuContainer>
        <Logo>
          <Link to={"/"} onClick={homeSection.onClick}>
            <ImgDesktop src={logo} alt={"owocedobiura.pl"} />
            <ImgMobile src={logo} alt={"owocedobiura.pl"} />
          </Link>
          <Link to={"https://betterworkplace.pl/"}>
            <ImgBetterWorkplace>
              <img src={betterworkplace} alt={"betterworkplace.pl"} />
            </ImgBetterWorkplace>
          </Link>
        </Logo>
      </MenuContainer>
    </Section>
  );
}

export default Top;
